export default function TransferCreditFilledIcon({
  width = 24,
  height = 24,
  inverse = false,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2.25A9.75 9.75 0 1 0 21.75 12 9.762 9.762 0 0 0 12 2.25Zm3.75 10.5h-3v3a.75.75 0 1 1-1.5 0v-3h-3a.75.75 0 1 1 0-1.5h3v-3a.75.75 0 1 1 1.5 0v3h3a.75.75 0 1 1 0 1.5Z"
      />
    </svg>
  );
}
